import { Box, Divider } from "@mui/material";
import Image from "next/image";
import { useContext } from "react";
import { LocalizationContext } from "../lib/context";

export default function BottomInfo({
  headerText,
  textsArray,
  sendEmail,
  email,
  transparent,
}: {
  headerText: string;
  textsArray: string[];
  sendEmail?: boolean;
  email?: string;
  transparent?: boolean;
}) {
  const { uiGeneral } = useContext(LocalizationContext).localeStrings;
  return (
    <div
      className="bottomInfo"
      style={transparent ? { background: "rgba(255, 255, 255, 0)" } : {}}
    >
      <div className="bottomInfo__main">
        <div className="bottomInfo__header">{headerText}</div>
        <Divider />

        {textsArray && textsArray.map((item, i) => <p key={i}>{item}</p>)}

        {sendEmail && (
          <Box sx={{ margin: "0 auto" }}>
            <Image src="/assets/email.png" alt="" width={15} height={12} />
            <a
              href={`mailto:${email}`}
              className="settings__underLineText"
              children={uiGeneral.contactUs2}
              style={{ marginLeft: "10px" }}
            />
          </Box>
        )}
      </div>
    </div>
  );
}
